export default "__VITE_ASSET__df410ffc__"